(() => {
  'use strict';
  document.querySelectorAll('.lu-offers').forEach(offers => {
    const noticeStrip = offers.classList.contains('lu-offers--notices');
    const slides = [...offers.querySelector('.lu-offers__group').querySelectorAll('[data-lu-offer]')];
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = motion.matches;
    const sync = () => {
      offers.dataset.paused = String(paused || document.hidden || offers.matches(':focus-within'));
    };
    offers.addEventListener('focusin', sync);
    offers.addEventListener('focusout', () => setTimeout(sync, 0));
    document.addEventListener('visibilitychange', sync);
    motion.addEventListener('change', () => { paused = motion.matches; sync(); });
    const show = n => {
      const slide = slides[(Number(n) + slides.length) % slides.length];
      slide.focus({ preventScroll: true });
      slide.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' });
      return slide.textContent.trim();
    };
    slides.forEach((slide, i) => window.__fudgeDebug?.action((noticeStrip ? 'Preview notice: ' : 'Preview announcement: ') + slide.querySelector('strong').textContent, () => show(i)));
    window.__fudgeDebug?.command(noticeStrip ? 'Show notice' : 'Show announcement', show);
    sync();
  });
  const menu = document.getElementById('lu-menu');
  const header = document.getElementById('lifty-site-header');
  const searchToggle = document.querySelector('[data-lu-search-toggle]');
  if (menu && header && searchToggle) {
    const setHeaderHeight = () => header.style.setProperty('--lu-header-height', header.offsetHeight + 'px');
    setHeaderHeight();
    if ('ResizeObserver' in window) new ResizeObserver(setHeaderHeight).observe(header);
    const summary = menu.querySelector('summary');
    let returnFocus = summary;
    const closeMenu = (restoreFocus = false) => {
      menu.open = false;
      searchToggle.setAttribute('aria-expanded', 'false');
      if (restoreFocus) returnFocus.focus();
    };
    summary.addEventListener('click', () => { returnFocus = summary; });
    searchToggle.addEventListener('click', () => {
      if (menu.open) { closeMenu(); return; }
      returnFocus = searchToggle;
      menu.open = true;
      searchToggle.setAttribute('aria-expanded', 'true');
      menu.querySelector('input[type="search"]').focus({ preventScroll: true });
    });
    menu.addEventListener('toggle', () => {
      searchToggle.setAttribute('aria-expanded', String(menu.open));
      if (menu.open) menu.querySelector('.lu-menu__panel').scrollTop = 0;
    });
    menu.querySelector('[data-lu-menu-close]').addEventListener('click', () => closeMenu(true));
    document.addEventListener('click', event => {
      if (menu.open && !menu.contains(event.target) && !searchToggle.contains(event.target)) closeMenu();
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) { event.preventDefault(); closeMenu(true); }
    });
    menu.querySelectorAll('.lu-links a,.lu-links button').forEach(link => link.addEventListener('click', () => closeMenu()));
    header.addEventListener('focusout', event => {
      if (event.relatedTarget && !header.contains(event.relatedTarget)) closeMenu();
    });
  }
  document.querySelectorAll('.lu-primary a,.lu-menu .lu-links a').forEach(link => {
    if (link.pathname === window.location.pathname) link.setAttribute('aria-current', 'page');
  });
  const index = document.querySelector('[data-lu-index]');
  const main = document.getElementById('MainContent');
  if (!index || !main || document.body.classList.contains('template-cart') || document.body.classList.contains('template-search')) return;
  const seen = new Set();
  const candidates = [...main.querySelectorAll('h2')].filter(heading => {
    if (heading.closest('.lu-wayfinding,.lifty-hero-slide,[aria-hidden="true"],dialog,[role="dialog"],.t4s-product,details,.lifty-product-card')) return false;
    return heading.getClientRects().length && heading.textContent.trim().length > 2;
  });
  const productPage = document.body.classList.contains('template-product');
  const selected = candidates.filter(heading => {
    const text = heading.textContent.trim().replace(/\s+/g, ' ');
    if (productPage && !/specification|size|fit|delivery|collection|question|review|overview|description|feature/i.test(text)) return false;
    return text.length < 100;
  }).slice(0,6);
  if (selected.length < 2) return;
  selected.forEach((heading, position) => {
    const text = heading.textContent.trim().replace(/\s+/g, ' ');
    const label = text.charAt(0) + text.slice(1).toLowerCase();
    if (seen.has(label)) return;
    seen.add(label);
    if (!heading.id) {
      let id = 'lifty-page-section-' + (position + 1);
      while (document.getElementById(id)) id += '-section';
      heading.id = id;
    }
    const link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = label;
    index.querySelector('div').append(link);
  });
  if (seen.size > 1) index.hidden = false;
})();
